import fetch from '@/lib/fetch';
import { SERVER } from '@/constants/servers';

export const fetchOSSToken = () => fetch(`${SERVER}/study-main/aliyun/oss/token/fetch`, {}, {
  method: 'post',
});
